<template>
    <div class="RoleChangeConfirmationProcedureDescription">
        {{ changeText }} <span>{{ userName }}</span> to {{ article }} <span>{{ roleLabel }}</span> {{ gainOrLoseText }}
    </div>
</template>

<style lang="scss">
.RoleChangeConfirmationProcedureDescription {
    span {
        @apply text-eidTrustGreen;
        font-weight: 500;
    }
}
</style>

<script lang="ts">
    import { defineComponent, PropType } from 'vue';

    import { RoleChangeType } from '../type';

    export default defineComponent({
        name: 'RoleChangeConfirmationProcedureDescription',
        props: {
            userName: {
                type: String,
                required: true,
            },
            roleLabel: {
                type: String,
                required: true,
            },
            changeType: {
                type: String as PropType<RoleChangeType>,
                required: true,
            },
        },
        computed: {
            changeText(): string {
                return this.changeType === RoleChangeType.downgrade ? 'By changing' : 'Changing';
            },
            article(): string {
                return /^[aeiou]/i.test(this.roleLabel) ? 'an' : 'a';
            },
            gainOrLoseText(): string {
                return this.changeType === RoleChangeType.downgrade
                    ? 'the user will no longer be able to:'
                    : 'will allow them to:';
            },
        },
    });
</script>
